

export const Price_Formation = (num) => {
  return  num.toLocaleString("hi-IN", {style:"currency", currency:"INR"});
}
